import { apiFetch } from "./auth";
import { pickField } from "./fieldHelpers";

// Contact role codes come from Epicor's RoleCd table — the same list Epicor
// validates CustCnt.RoleCode against. Hardcoding them caused "A valid Role is
// required" for codes that don't exist in this company. Fetched once and cached
// for the session; falls back to the legacy list if the call fails.
const API_URL = process.env.REACT_APP_API_URL;

// The roles a CUSTOMER contact may carry (Kapil 2026-10-31, Google sheet DEF-10): the full RoleCd
// list also holds staff roles (IT, CEO, Sales Rep ...). ShpRec stays for ship-to receivers, whose
// contacts default to it. A contact that already carries another code still shows it (callers
// prepend the current value).
export const CONTACT_ROLES = ["Purch", "A-P", "Owner", "Manager", "Dir", "Invoice Recipient", "ShpRec"];

export const ROLE_FALLBACK = CONTACT_ROLES;

const f = (o, k, d = "") => { const v = pickField(o, k); return v === undefined || v === null ? d : v; };

let cache = null;

export async function fetchRoleCodes() {
  if (cache) return cache;
  try {
    const r = await apiFetch(`${API_URL}/api/RoleCd`);
    const data = await r.json().catch(() => null);
    const list = (data && (data.roleCds || data.RoleCds)) || [];
    const active = new Set(list
      .filter((rc) => !f(rc, "Inactive", false))
      .map((rc) => f(rc, "RoleCode"))
      .filter(Boolean));
    // Keep the allowed order; drop any allowed code Epicor does not have (or has made inactive).
    const codes = CONTACT_ROLES.filter((c) => active.has(c));
    if (codes.length) { cache = codes; return codes; }
  } catch { /* fall through to the fallback list */ }
  return ROLE_FALLBACK;
}
